'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixParent = require('../utils/mix-parent.js');

exports.default = {
  mixins: [(0, _mixParent.mixParent)('dof-row')],
  props: {
    gap: {
      type: Number,
      default: 20
    }
  }
}; //
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-row/index.vue
// module id = 379
// module chunks = 0 1